export const IS_DEV = process.env.NODE_ENV === 'development';
// TODO change the app production url
export const APP_URL = IS_DEV
  ? 'http://localhost:3000'
  : 'https://nanoreads.com/app/';
export const APP_VERSION = '2.0.4';
